import { render, staticRenderFns } from "./rectangle.vue?vue&type=template&id=960060ba&scoped=true&"
import script from "./rectangle.vue?vue&type=script&lang=js&"
export * from "./rectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960060ba",
  null
  
)

export default component.exports